import RpcService     from '@/core/services/Rpc/RpcService';
import RpcResponse     from '@/core/services/Rpc/RpcResponse';
import type EntityPointer from '@/domains/EntityPointer/EntityPointer';
import type TimeStamp     from '@/core/types/TimeStamp';

/**
 * DAO для работы с фидами.
 *
 * feeds.get — приватный фид, feeds.getPublic — маскированный публичный.
 * parentEntity — один указатель или массив: бэк штатно итерирует список,
 * это легальная замена прежнему каскаду extraParentEntities.
 */
class FeedsDAO {

	/**
	 * Загружает записи фида для одной или нескольких родительских сущностей.
	 */
	static async get(
		parentEntity: EntityPointer | EntityPointer[],
		feedTypes?: string[],
		timeFrom?: TimeStamp,
    isPublic?: boolean,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest('feeds.get', {
			parentEntity,
			feedTypes,
			timeFrom,
      isPublic,
		});
	}
}

export default FeedsDAO;
